import { ItemContainerDTO } from '../../../typings//windreamWebService/Windream.WebService';
import { DocumentResponseContainerDTO } from '../../../typings/windreamWebService/Windream.WebService.Documents';
import { IServiceResponse } from '../../ajaxHandler';
import { GlobalConfig } from '../../config';
import { HttpResourcePointer, IRequestExecutor } from '../../dataProviders';
import { Logger } from '../../logging';
import { ServiceError } from '../common';
import { IdentityMapper } from '../identityMapper';
import { WindreamRequestOptions } from '../models';
import { ServiceAction } from '../serviceAction';

/**
 * Set a document as the current version.
 *
 * @export
 * @class SetAsCurrentVersion
 * @extends {ServiceAction}
 */
export class SetAsCurrentVersion extends ServiceAction {

    /**
     * Creates an instance of SetAsCurrentVersion.
     * @param {IRequestExecutor} requestExecutor
     * @param {GlobalConfig} globalConfig
     * @param {Logger} logger
     * @memberof SetAsCurrentVersion
     */
    public constructor(requestExecutor: IRequestExecutor, globalConfig: GlobalConfig, logger: Logger) {
        super(requestExecutor, globalConfig, logger);
        this.name = 'setAsCurrentVersion';
    }


    /**
     * Sets a document as the current version.
     *
     * @param {WindreamRequestOptions} windreamRequestOptions The request options.
     * @return {Promise<void>}
     * @memberof SetAsCurrentVersion
     */
    public async do(windreamRequestOptions: WindreamRequestOptions): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.requestExecutor.executeRequest(new HttpResourcePointer('POST', this.globalConfig.windreamWebServiceURL + '/documents/SetAsCurrentVersion', {
                Item: IdentityMapper.getWebServiceIdentity(windreamRequestOptions.identity)
            } as ItemContainerDTO), windreamRequestOptions.requestOptions).then((response: IServiceResponse<DocumentResponseContainerDTO>) => {
                if (response.data && !response.data.HasErrors) {
                    resolve();
                } else {
                    this.logger.error('SetAsCurrentVersion', 'do', 'Failed to set current document as current version', response);
                    reject(new ServiceError('Failed to set document as current version', response.data?.Error?.ErrorCode || -1));
                }
            }).catch((err: Error) => {
                this.logger.error('SetAsCurrentVersion', 'do', 'Failed to execute request', err);
                reject(err);
            });
        });
    }
}